import type { ReviewHistoryItem } from "../application/round02-service";
import { reviewIssueLabel } from "../domain/review-labels";

const VERIFICATION_LABELS = {
  completed: "已完成",
  partially_completed: "部分完成",
  not_completed: "未完成",
  blocked_external: "外部原因无法执行",
  unreasonable: "原纠偏不合理",
} as const;

export function History({ items }: { items: ReviewHistoryItem[] }) {
  const completedCorrections = items.filter(
    (item) => item.correction?.verification?.result === "completed",
  ).length;
  const repeated = new Map<string, number>();
  for (const item of items.slice(0, 7)) {
    if (item.review.issueType) {
      repeated.set(item.review.issueType, (repeated.get(item.review.issueType) ?? 0) + 1);
    }
  }
  const repeatedLabel = [...repeated.entries()]
    .filter(([, count]) => count > 1)
    .sort((left, right) => right[1] - left[1])[0];

  return (
    <main className="history-page">
      <header className="page-header">
        <span className="brand">CEO OS</span>
        <h1>复盘历史</h1>
        <p>这里只汇总已经发生的记录，不评价能力或人格。</p>
      </header>

      <section className="history-summary" aria-label="最近七天事实计数">
        <div>
          <strong>{items.slice(0, 7).length}</strong>
          <span>近 7 条完成复盘</span>
        </div>
        <div>
          <strong>{completedCorrections}</strong>
          <span>已完成行为纠偏</span>
        </div>
        <div>
          <strong>{repeatedLabel ? `${repeatedLabel[1]} 次` : "无"}</strong>
          <span>{repeatedLabel ? `重复问题：${repeatedLabel[0]}` : "重复问题记录"}</span>
        </div>
      </section>

      {items.length === 0 ? (
        <div className="empty-state">
          <strong>还没有完成的复盘</strong>
          <p>完成第一次复盘后，这里会显示日期、偏差、纠偏和验证事实。</p>
        </div>
      ) : (
        <div className="history-list">
          {items.map((item) => (
            <details className="history-item" key={item.review.id}>
              <summary>
                <span>
                  <strong>{item.review.reviewDate}</strong>
                  <small>{item.review.reviewMode === "quick" ? "快速复盘" : "完整复盘"}</small>
                </span>
                <span className="history-status">{item.exported ? "已导出" : "仅本地"}</span>
              </summary>
              <dl className="history-detail">
                <div>
                  <dt>最大个人偏差</dt>
                  <dd>{item.review.founderDeviation}</dd>
                </div>
                <div>
                  <dt>行为纠偏</dt>
                  <dd>{item.correction?.action ?? "没有保存纠偏"}</dd>
                </div>
                <div>
                  <dt>验证结果</dt>
                  <dd>
                    {item.correction?.verification
                      ? VERIFICATION_LABELS[item.correction.verification.result]
                      : "等待次日验证"}
                  </dd>
                </div>
                <div>
                  <dt>问题类型</dt>
                  <dd>{reviewIssueLabel(item.review.issueType)}</dd>
                </div>
              </dl>
            </details>
          ))}
        </div>
      )}
    </main>
  );
}
